import React, { FC, useState }               from "react";
import { useDispatch, useSelector }          from "react-redux";
import { Button, Icon, Modal, Radio, Table } from "semantic-ui-react";
import GetMailTemplates                      from "../../../application/usecase/mail/template/GetMailTemplates";
import CurrentPage                           from "../../../domain/fundamentals/pagination/CurrentPage";
import MailSendContent                       from "../../../domain/mail/send/MailSendContent";
import MailSendRepository                    from "../../../domain/mail/send/MailSendRepository";
import MailSendSubject                       from "../../../domain/mail/send/MailSendSubject";
import MailTemplate                          from "../../../domain/mail/template/MailTemplate";
import MailTemplates                         from "../../../domain/mail/template/MailTemplates";
import { ResKaState }                        from "../../../index";
import MailSendDataSource                    from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import BottomSection                         from "../common/layout/BottomSection";
import ListTotalCount                        from "../common/layout/ListTotalCount";
import ListPagination                        from "../common/ListPagination";

const MailSendTemplateSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedMailTemplate, setMailTemplate] = useState(new MailTemplate());
  const mailTemplates: MailTemplates = useSelector((state: ResKaState) => state.mailTemplates);
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());
  const getMailTemplates: GetMailTemplates = new GetMailTemplates(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          getMailTemplates.execute(new CurrentPage());
          setOpen(true);
          setMailTemplate(new MailTemplate());
        } }
      >
        <Icon name="mail"/>
        メール雛形を選択する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>メール雛形の選択</Modal.Header>

        <Modal.Content>
          {
            mailTemplates.isEmpty()
              ?
              <p>メール雛形が作成されていません。</p>
              :
              <>
                <ListTotalCount>{ mailTemplates.count.toString() }</ListTotalCount>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>選択</Table.HeaderCell>
                      <Table.HeaderCell>メール雛形名称</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      mailTemplates.toList().map(mailTemplate => (
                        <Table.Row onClick={ () => setMailTemplate(mailTemplate) }>
                          <Table.Cell width={ 2 }>
                            <Radio
                              name="mailTemplate"
                              checked={ mailTemplate.id.equals(selectedMailTemplate.id) }
                              onChange={ () => setMailTemplate(mailTemplate) }
                            />
                          </Table.Cell>
                          <Table.Cell>
                            { mailTemplate.name.value }
                          </Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>

                <BottomSection>
                  <ListPagination
                    currentPage={ mailTemplates.pagination.current }
                    totalPage={ mailTemplates.pagination.total }
                    onChangePage={ currentPage => getMailTemplates.execute(currentPage) }
                  />
                </BottomSection>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ selectedMailTemplate.id.isEmpty() }
            positive={ !selectedMailTemplate.id.isEmpty() }
            onClick={ () => {
              repository.setMailSendSubject(new MailSendSubject(selectedMailTemplate.subject.value));
              repository.setMailSendContent(new MailSendContent(selectedMailTemplate.content.value));
              setOpen(false);
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailSendTemplateSelector;
